module.exports = __webpack_public_path__ + "img/electricalCircuit_sign.6525c6b7.png";